export function ToBracketedCommaList(array: string[]): string {
  const l = ToCommaList(array);
  return l ? `( ${l.replaceAll('.', '')} )` : '';
}

export function ToCommaList(array: string[]): string {
  const newArray = array.filter((x) => !!x);
  if (newArray.length === 0) {
    return '';
  }
  if (newArray.length === 1) {
    return `${array[0]}.`;
  }
  const list = [...newArray];
  const last = list.pop();
  return `${list.join(', ')} and ${last}.`;
}

export function ToInlineCommaList(array: string[]): string {
  const res = ToCommaList(array);
  return res.length == 0 ? '' : res.substring(0, res.length - 1);
}

export function TruncateString(s: string, maxLength: number) {
  if (!s || s.length <= maxLength) {
    return s;
  }
  return `${s.substring(0, maxLength - 3)}...`;
}
